import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';

import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockVkVideo.module.scss';
import { ContentBlockVkVideoProps } from './ContentBlockVkVideo.types';

export function ContentBlockVkVideo({
  iframe,
  description,
  ...sectionProps
}: ContentBlockVkVideoProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <figure>
        {iframe && (
          <div className={styles.iframeWrapper}>
            <iframe
              allowFullScreen
              src={iframe.src}
              className={styles.iframe}
              allow="encrypted-media; fullscreen; picture-in-picture;"
            />
          </div>
        )}

        {description && (
          <figcaption className={styles.description}>
            <Typography
              tagName={TypographySizes.span}
              mods={[TypographyMods.bodyM]}
            >
              {description}
            </Typography>
          </figcaption>
        )}
      </figure>
    </ContentBlockWrapper>
  );
}
